import { render, staticRenderFns } from "./ProductManual.vue?vue&type=template&id=1565b454&scoped=true&"
import script from "./ProductManual.vue?vue&type=script&lang=js&"
export * from "./ProductManual.vue?vue&type=script&lang=js&"
import style0 from "./ProductManual.vue?vue&type=style&index=0&id=1565b454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1565b454",
  null
  
)

component.options.__file = "ProductManual.vue"
export default component.exports